import React from 'react'
import logo from '../logo.jpg'

export default props => {
    return (
        <img alt="DelaDele" {...props} src={logo}></img>
    )
}